import { makeStyles } from "tss-react/mui"
import { blueGrey } from "../../../themes/palette"

export const useStyles = makeStyles()(({ spacing }) => ({
  dialogPaper: {
    alignItems: "center"
  },
  dialogTitle: {
    padding: spacing(5)
  },
  dialogContent: {
    padding: spacing(0, 6, 5)
  },
  dialogActions: {
    width: "100%"
  },
  timer: {
    padding: spacing(2, 4),
    borderRadius: "5px",
    border: `1px solid ${blueGrey[100]}`
  }
}))
